import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import addMessages from './editStudentAddConfirmationMessages';
import editMessages from './editStudentEditConfirmationMessages';
import { Modal } from 'sa-ui/';
import ModalType from './editClassModalType';

function getMessages(type) {
  switch (type) {
    case ModalType.ADD:
      return addMessages;
    case ModalType.EDIT:
      return editMessages;
    default:
      return undefined;
  }
}

const EditStudentConfirmationModal = props => {
  const messages = getMessages(props.type);
  return (
    <Modal
      show={props.show}
      onClose={props.onClose}
      icon="ti-thumb-up"
      title={<FormattedMessage {...messages.title} />}
      subtitle={<FormattedMessage {...messages.subtitle}/>}
      buttons={[
        {
          label: <FormattedMessage {...messages.continue} />,
          onClick: props.onClose,
          primary: true,
        },
      ]}
    >
    </Modal>
  );
};

EditStudentConfirmationModal.propTypes = {};

EditStudentConfirmationModal.defaultProps = {
  type: ModalType.ADD,
};

export default EditStudentConfirmationModal;
